export type PlatformType = 'ipad' | 'fire';

const platformNames = {
  ipad: 'iPad',
  fire: 'Fire',
};

export default function platformName(platform: PlatformType): string {
  return platformNames[platform] || platform;
}
